// Homepage "about" section defaults (EN + FR): today's text. Stat values are the number
// plus its suffix as shown ("70,000+"); *asterisks* in the title mark the highlighted word.
// "{urgentShort}" is the urgent-staffing promise (src/utils/promises.js; homepage: "1–4 hrs").
// The photo is not here: the built-in photo in src/Sections/About is the fallback.
const ABOUT_DEFAULTS = {
  "en": {
    "stats": [
      { "value": "1 Billion+", "label": "Assets Secured" },
      { "value": "{urgentShort}", "label": "Urgent staffing" },
      { "value": "70,000+", "label": "Largest Crowd Secured" },
      { "value": "100%", "label": "Client Satisfaction Rate" }
    ],
    "imageAlt": "About Vision Security",
    "eyebrow": "Why choose Vision",
    "title": "Raising the *standard* of the security industry",
    "text": "At Vision, our mission is to raise the standard of excellence in the security industry while creating meaningful opportunities for those who demonstrate dedication, integrity, and passion for protecting others.",
    "points": [
      {
        "title": "Elite Hiring Standards",
        "desc": "Less than 15% of applicants earn a place on our team. Every officer undergoes background checks, in-house combat and de-escalation training, and ongoing performance evaluations."
      },
      {
        "title": "Real-Time Technology",
        "desc": "Live GPS tracking, digital incident reports with photos, and centralized dispatch give you full visibility into your security operation at all times."
      },
      {
        "title": "End-to-End Security Solutions",
        "desc": "From uniformed guards and mobile patrols to intervention agents and security systems — one trusted partner covers every layer of protection."
      }
    ],
    "ctaLabel": "Learn More"
  },
  "fr": {
    "stats": [
      { "value": "1 milliard+", "label": "Actifs sécurisés" },
      { "value": "{urgentShort}", "label": "Déploiement urgent" },
      { "value": "70\u00a0000+", "label": "Plus grande foule sécurisée" },
      { "value": "100 %", "label": "Taux de satisfaction client" }
    ],
    "imageAlt": "À propos de Vision Security",
    "eyebrow": "Pourquoi choisir Vision",
    "title": "Élever les *standards* de l'industrie de la sécurité",
    "text": "Chez Vision, notre mission est d'élever les standards d'excellence dans l'industrie de la sécurité tout en créant des opportunités significatives pour celles et ceux qui font preuve de dévouement, d'intégrité et de passion pour protéger les autres.",
    "points": [
      {
        "title": "Normes d’embauche d’élite",
        "desc": "Moins de 15\u00a0% des candidats obtiennent une place dans notre équipe. Chaque agent subit une vérification des antécédents, une formation interne en combat et en désescalade, ainsi que des évaluations de performance continues."
      },
      {
        "title": "Technologie en temps réel",
        "desc": "Suivi GPS en direct, rapports d’incidents numériques avec photos et répartition centralisée vous offrent une visibilité complète sur votre opération de sécurité en tout temps."
      },
      {
        "title": "Solutions de sécurité complètes",
        "desc": "Des agents en uniforme et patrouilles mobiles aux agents d’intervention et systèmes de sécurité — un seul partenaire de confiance couvre chaque couche de protection."
      }
    ],
    "ctaLabel": "En savoir plus"
  }
};

export default ABOUT_DEFAULTS;
